module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel202309_04_770_280_ja-c98849f9872a84b23cbccdb82a21d975.jpg";